export const readableMessageTypes = {
  'OSSVRE-MSG.MOSS': 'OSSVRE-MSG.MOSS',
  'OSSVRE-MSG.VOES': 'OSSVRE-MSG.VOES',
  'OSSVRE-MSG.IMP': 'OSSVRE-MSG.IMP',
  'OSSVRI-MSG.MOSS': 'OSSVRI-MSG.MOSS',
  'OSSVRI-MSG.VOES': 'OSSVRI-MSG.VOES',
  'OSSVRI-MSG.IMP': 'OSSVRI-MSG.IMP',
  'OSSVRMSCON-MSG.MOSS': 'OSSVRMSCON-MSG.MOSS',
  'OSSVRMSCON-MSG.VOES': 'OSSVRMSCON-MSG.VOES',
  'OSSVRMSCON-MSG.IMP': 'OSSVRMSCON-MSG.IMP',
  'OSSVRQ-MSG.MOSS': 'OSSVRQ-MSG.MOSS',
  'OSSVRQ-MSG.VOES': 'OSSVRQ-MSG.VOES',
  'OSSVRQ-MSG.IMP': 'OSSVRQ-MSG.IMP',
  'PMT-MSG.MOSS': 'PMT-MSG.MOSS',
  'PMT-MSG.VOES': 'PMT-MSG.VOES',
  'PMT-MSG.IMP': 'PMT-MSG.IMP',
  'PRI-MSG.MOSS': 'PRI-MSG.MOSS',
  'PRI-MSG.VOES': 'PRI-MSG.VOES',
  'PRI-MSG.IMP': 'PRI-MSG.IMP',
  'REG-MSG.MOSS': 'REG-MSG.MOSS',
  'REG-MSG.VOES': 'REG-MSG.VOES',
  'REG-MSG.IMP': 'REG-MSG.IMP',
  'RFI-MSG.MOSS': 'RFI-MSG.MOSS',
  'RFI-MSG.VOES': 'RFI-MSG.VOES',
  'RFI-MSG.IMP': 'RFI-MSG.IMP',
  'RQE-MSG.MOSS': 'RQE-MSG.MOSS',
  'RQE-MSG.VOES': 'RQE-MSG.VOES',
  'RQE-MSG.IMP': 'RQE-MSG.IMP',
  'RQI-MSG.MOSS': 'RQI-MSG.MOSS',
  'RQI-MSG.VOES': 'RQI-MSG.VOES',
  'RQI-MSG.IMP': 'RQI-MSG.IMP',
  'TEM-MSG.MOSS': 'TEM-MSG.MOSS',
  'TEM-MSG.VOES': 'TEM-MSG.VOES',
  'TEM-MSG.IMP': 'TEM-MSG.IMP',
  'VRR-MSG.MOSS': 'VRR-MSG.MOSS',
  'VRR-MSG.VOES': 'VRR-MSG.VOES',
  'VRR-MSG.IMP': 'VRR-MSG.IMP',
  'VRMSCON-MSG.MOSS': 'VRMSCON-MSG.MOSS',
  'VRMSCON-MSG.VOES': 'VRMSCON-MSG.VOES',
  'VRMSEST-MSG.MOSS': 'VRMSEST-MSG.MOSS',
  'OSSVRMSEST-MSG.MOSS': 'OSSVRMSEST-MSG.MOSS',
  'VRQ-MSG.MOSS': 'VRQ-MSG.MOSS',
  'VRQ-MSG.VOES': 'VRQ-MSG.VOES',
  'VRI-MSG.MOSS': 'VRI-MSG.MOSS',
  'VRI-MSG.VOES': 'VRI-MSG.VOES',
  'VRE-MSG.MOSS': 'VRE-MSG.MOSS',
  'VRE-MSG.VOES': 'VRE-MSG.VOES',
  'RIB-MSG.MOSS': 'RIB-MSG.MOSS',
  'RIB-MSG.VOES': 'RIB-MSG.VOES',
  'RIB-MSG.IMP': 'RIB-MSG.IMP',
  'PRC-MSG.MOSS': 'PRC-MSG.MOSS',
  'PRC-MSG.VOES': 'PRC-MSG.VOES',
  'PRC-MSG.IMP': 'PRC-MSG.IMP',
};
